import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    correo: '',
    mensaje: '',
    telefono: '', // campo honeypot
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://seinsv.com/api/enviar-mensaje/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
  
      if (res.ok) {
        alert('Mensaje enviado correctamente');
        setFormData({
          nombre: '',
          correo: '',
          mensaje: '',
          telefono: '', // Reinicia los valores a vacíos
        });
      } else {
        const data = await res.json();
        alert(`Error del servidor: ${data.error || res.statusText}`);
      }
    } catch (err) {
      console.error("Error al enviar el formulario:", err);
      alert(`Error inesperado: ${err.message || 'Error desconocido'}`);
    }
  };

  return (
    <section id="contacto" style={{ padding: '4rem 1rem', background: '#ffffff' }}>
      <h2 style={{ textAlign: 'center' }}>Contáctanos</h2>
      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: '600px',
          margin: '2rem auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <input 
          type="text" 
          name="nombre" 
          placeholder="Nombre" 
          required 
          value={formData.nombre} // Vincula al estado
          onChange={handleChange} 
        />
        <input 
          type="email" 
          name="correo" 
          placeholder="Correo electrónico" 
          required 
          value={formData.correo} // Vincula al estado
          onChange={handleChange} 
        />
        <textarea 
          name="mensaje" 
          placeholder="Mensaje" 
          rows="5" 
          required 
          value={formData.mensaje} // Vincula al estado
          onChange={handleChange} 
        />
        
        {/* Campo honeypot oculto */}
        <input
          type="text"
          name="telefono"
          value={formData.telefono}
          onChange={handleChange}
          style={{ display: 'none' }}
          tabIndex="-1"
          autoComplete="off"
        />

        <button type="submit" style={{ padding: '1rem', background: '#001f3f', color: 'white', border: 'none' }}>
          Enviar
        </button>
      </form>

      {/* Iconos de contacto */}
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <h3>También puedes contactarnos a través de:</h3>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem' }}>
          <a href="https://wa.me/50375379826?text=Hola%2C%20estoy%20interesado%20en%20sus%20servicios."
          target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#25D366' }}>
            <FontAwesomeIcon icon={faWhatsapp} size="3x" />
            <p>WhatsApp</p>
          </a>
          <a href="tel:+50375379826" style={{ textDecoration: 'none', color: '#007bff' }}>
            <FontAwesomeIcon icon={faPhone} size="3x" />
            <p>Teléfono</p>
          </a>
          <a href="mailto:administracion@seinsv.com" style={{ textDecoration: 'none', color: '#007bff' }}>
            <FontAwesomeIcon icon={faEnvelope} size="3x" />
            <p>Correo</p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contacto;

